// src/pages/Forbidden.jsx
import { Link } from "react-router-dom";
import { FaBan, FaArrowLeft } from "react-icons/fa";

const Forbidden = () => {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-100 text-gray-800 px-6">
      <div className="flex items-center gap-4">
        <FaBan className="text-red-600 text-6xl" />
        <h1 className="text-5xl font-extrabold text-red-700">403 - Forbidden</h1>
      </div>

      <p className="mt-6 text-lg text-gray-600 max-w-xl text-center">
        شما اجازه دسترسی به این صفحه را ندارید.
        لطفاً به صفحه اصلی نرم‌افزار بازگردید یا از منو استفاده کنید.
      </p>

      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300 shadow-md"
      >
        <FaArrowLeft />
        بازگشت به خانه
      </Link>

      <footer className="mt-10 text-sm text-gray-400">
        © {new Date().getFullYear()} اوژن تجارت کیان - تمام حقوق محفوظ است.
      </footer>
    </div>
  );
};

export default Forbidden;
